import { CustomsInfo } from './../../shared/order/customs-info';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'osca-customs-info',
  templateUrl: './customs-info.component.html',
  styles: []
})
export class CustomsInfoComponent implements OnInit {
  @Input() customsInfo: CustomsInfo;

  constructor() { }

  ngOnInit() {
  }

}
